import { useAppDispatch, useAppSelector } from '@/state/hooks';
import { selectOrderModalOpened, setOrderModalDisclosure } from '@/state/reducers/orderSlice';
import { UseDisclosureReturn } from './useDisclosure';

export interface UseOrderDisclosureReturn {}

const useOrderDisclosure = (): UseDisclosureReturn => {
    const dispatch = useAppDispatch();
    const orderOpened = useAppSelector(selectOrderModalOpened);

    return [
        orderOpened,
        {
            open: () => {
                dispatch(setOrderModalDisclosure(true));
            },
            close: () => {
                dispatch(setOrderModalDisclosure(false));
            },
            toggle: () => {
                dispatch(setOrderModalDisclosure(!orderOpened));
            }
        }
    ];
};

export default useOrderDisclosure;
